import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetPartnerAdminsClient } from '~/hooks';

type Args = {
  clientId: number;
};

/**
 * 利用企業編集ヘッダーコンポーネント専用フック
 * 利用企業名を取得して返す
 */
export const useEditClientHeader = ({ clientId }: Args) => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data } = useGetPartnerAdminsClient({ threeLetterCode, clientId });

  return { clientName: data.client.name };
};
